import React from 'react';
import { List } from 'framework/list';
import usePurchaseOrderService from 'domain/finance/purchaseOrder/usePurchaseOrderService';
import { SensitiveListElementLayout } from 'framework/sensitiveData';
import { usePurchaseOrderUrl } from 'domain/finance/purchaseOrder/shared/usePurchaseOrderRouting';
import PurchaseOrderListPageContent from 'domain/finance/purchaseOrder/List/PurchaseOrderListPageContent';

const PurchaseOrderListPage = () => {
  const { search, getSensitiveDataByIds } = usePurchaseOrderService();
  const { getListUrl } = usePurchaseOrderUrl();

  return (
    <List getDataMethod={search} defaultFilter={{}}>
      <SensitiveListElementLayout
        sensitiveDataIdSource="id"
        loadSensitiveDataMethod={getSensitiveDataByIds}
        timerId={getListUrl()}
      >
        <PurchaseOrderListPageContent />
      </SensitiveListElementLayout>
    </List>
  );
};

export default PurchaseOrderListPage;
